import Images from "../../../Images"
import ach_credit_transfer from "../../../Images/wallets/ach_credit_transfer.png"
import acss_debit from "../../../Images/wallets/acss_debit.png"
import addi from "../../../Images/wallets/addi.png"
import affirm from "../../../Images/wallets/affirm.png"
import afterpay_clearpay from "../../../Images/wallets/afterpay_clearpay.png"
import alipay from "../../../Images/wallets/alipay.png"
import amazon_pay from "../../../Images/wallets/amazon_pay.png"
import amex_express_checkout from "../../../Images/wallets/amex_express_checkout.png"
import aplazo from "../../../Images/wallets/aplazo.png"
import apple_pay from "../../../Images/wallets/apple_pay.png"
import au_becs_debit from "../../../Images/wallets/au_becs_debit.png"
import bacs_debit from "../../../Images/wallets/bacs_debit.png"
import bancontact from "../../../Images/wallets/bancontact.png"
import bank_transfer from "../../../Images/wallets/bank_transfer.png"
import billie from "../../../Images/wallets/billie.png"
import bizum from "../../../Images/wallets/bizum.png"
import blik from "../../../Images/wallets/blik.png"
import boleto from "../../../Images/wallets/boleto.png"
import boodil from "../../../Images/wallets/boodil.png"
import card from "../../../Images/wallets/card.png"
import cartes_bancaires from "../../../Images/wallets/cartes_bancaires.png"
import cash_delivery from "../../../Images/wallets/cash_delivery.png"
import cash from "../../../Images/wallets/cash.png"
import cashapp from "../../../Images/wallets/cashapp.png"
import crypto from "../../../Images/wallets/crypto.png"
import customer_balance from "../../../Images/wallets/customer_balance.png"
import ebay from "../../../Images/wallets/ebay.png"
import eps from "../../../Images/wallets/eps.png"
import fpx from "../../../Images/wallets/fpx.png"
import giftcard from "../../../Images/wallets/giftcard.png"
import giropay from "../../../Images/wallets/giropay.png"
import google_pay from "../../../Images/wallets/google_pay.png"
import grabpay from "../../../Images/wallets/grabpay.png"
import ideal from "../../../Images/wallets/ideal.png"
import in3 from "../../../Images/wallets/in3.png"
import kakao_pay from "../../../Images/wallets/kakao_pay.png"
import klarna from "../../../Images/wallets/klarna.png"
import konbini from "../../../Images/wallets/konbini.png"
import kr_card from "../../../Images/wallets/kr_card.png"
import link from "../../../Images/wallets/link.png"
import masterpass from "../../../Images/wallets/masterpass.png"
import mb_way from "../../../Images/wallets/mb_way.png"
import mercado_pago from "../../../Images/wallets/mercado_pago.png"
import meta_pay from "../../../Images/wallets/meta_pay.png"
import mobilepay from "../../../Images/wallets/mobilepay.png"
import money_order from "../../../Images/wallets/money_order.png"
import multibanco from "../../../Images/wallets/multibanco.png"
import naver_pay from "../../../Images/wallets/naver_pay.png"
import none from "../../../Images/wallets/None.png"
import nz_bank_account from "../../../Images/wallets/nz_bank_account.png"
import offline from "../../../Images/wallets/offline.png"
import oxxo from "../../../Images/wallets/oxxo.png"
import p24 from "../../../Images/wallets/p24.png"
import paidy from "../../../Images/wallets/paidy.png"
import pay_by_bank from "../../../Images/wallets/pay_by_bank.png"
import payco from "../../../Images/wallets/payco.png"
import payflex from "../../../Images/wallets/payflex.png"
import paynow from "../../../Images/wallets/paynow.png"
import paypal from "../../../Images/wallets/paypal.png"
import paypay from "../../../Images/wallets/paypay.png"
import payto from "../../../Images/wallets/payto.png"
import pix from "../../../Images/wallets/pix.png"
import promptpay from "../../../Images/wallets/promptpay.png"
import radar_options from "../../../Images/wallets/radar_options.png"
import rakuten_pay from "../../../Images/wallets/rakuten_pay.png"
import rbcpayplan from "../../../Images/wallets/rbcpayplan.png"
import revolut_pay from "../../../Images/wallets/revolut_pay.png"
import riverty from "../../../Images/wallets/riverty.png"
import samsung_pay from "../../../Images/wallets/samsung_pay.png"
import satispay from "../../../Images/wallets/satispay.png"
import sepa_debit from "../../../Images/wallets/sepa_debit.png"
import sezzle from "../../../Images/wallets/sezzle.png"
import shop_pay from "../../../Images/wallets/shop_pay.png"
import shopify_pay from "../../../Images/wallets/shopify_pay.png"
import sistecredito from "../../../Images/wallets/sistecredito.png"
import sofort from "../../../Images/wallets/sofort.png"
import swish from "../../../Images/wallets/swish.png"
import synchrony from "../../../Images/wallets/synchrony.png"
import tabby from "../../../Images/wallets/tabby.png"
import tiktok_shop from "../../../Images/wallets/tiktok_shop.png"
import trustly from "../../../Images/wallets/trustly.png"
import twint from "../../../Images/wallets/twint.png"
import upi from "../../../Images/wallets/upi.png"
import us_bank_account from "../../../Images/wallets/us_bank_account.png"
import venmo from "../../../Images/wallets/venmo.png"
import walmart from "../../../Images/wallets/walmart.png"
import wachat_pay from "../../../Images/wallets/wechat_pay.png"
import zip from "../../../Images/wallets/zip.png"

export const paymentMethodsImages = {
  Affirm: affirm,
  "Afterpay / Clearpay": afterpay_clearpay,
  Afterpay: afterpay_clearpay,
  Alipay: alipay,
  "Amazon Pay": amazon_pay,
  Bancontact: bancontact,
  BLIK: blik,
  "Cash App": cashapp,
  "Customer Balance": customer_balance,
  EPS: eps,
  iDEAL: ideal,
  "Kakao Pay": kakao_pay,
  Klarna: klarna,
  "KR Card": kr_card,
  Link: link,
  Other: none,
  "P24 (Przelewy24)": p24,
  PayPal: paypal,
  PIX: pix,
  "Samsung Pay": samsung_pay,
  "SEPA Debit": sepa_debit,
  Twint: twint,
  "US Bank Account": us_bank_account,
  "Apple Pay": apple_pay,
  "Google Pay": google_pay,
  "Link Card": link,
  "NAVER Pay": naver_pay,
  "ACH Credit Transfer": ach_credit_transfer,
  Crypto: crypto,
  "WeChat Pay": wachat_pay,
  "Amex Express Checkout": amex_express_checkout,
  Masterpass: masterpass,
  "ACSS Debit": acss_debit,
  "AU BECS Debit": au_becs_debit,
  "BACS Debit": bacs_debit,
  Billie: billie,
  Boleto: boleto,
  "Cartes Bancaires": cartes_bancaires,
  FPX: fpx,
  GiroPay: giropay,
  GrabPay: grabpay,
  Konbini: konbini,
  "MB WAY": mb_way,
  MobilePay: mobilepay,
  Multibanco: multibanco,
  "NZ Bank Account": nz_bank_account,
  OXXO: oxxo,
  Payco: payco,
  PayNow: paynow,
  PayPay: paypay,
  PayTo: payto,
  "Pay by Bank": pay_by_bank,
  PromptPay: promptpay,
  "Radar Options": radar_options,
  "Revolut Pay": revolut_pay,
  Satispay: satispay,
  SOFORT: sofort,
  Swish: swish,
  Zip: zip,
  "Stripe Account": Images.integration_stripe,
  "Shopify Pay": shopify_pay,
  UPI: upi,
  Bizum: bizum,

  "Gift Card": giftcard,
  "Shopify Payment": shopify_pay,
  "Shopify Payments": shopify_pay,
  Card: card,
  "Cash App Pay": cashapp,
  Venmo: venmo,
  "Vipps / MobilePay": mobilepay,
  TWINT: twint,
  "MB Way": mb_way,
  "Link (Stripe)": link,
  "Shop Pay": shop_pay,
  "Shop Pay Installments": shop_pay,
  Pix: pix,
  "Mercado Pago": mercado_pago,
  "Rakuten Pay": rakuten_pay,
  "Meta Pay": meta_pay,
  Sezzle: sezzle,
  Tabby: tabby,
  Paidy: paidy,
  Aplazo: aplazo,
  Sistecredito: sistecredito,
  Addi: addi,
  Payflex: payflex,
  Boodil: boodil,
  Riverty: riverty,
  in3: in3,
  Synchrony: synchrony,
  "RBC PayPlan": rbcpayplan,
  Przelewy24: p24,
  Trustly: trustly,
  "Bank Transfer": bank_transfer,
  "Cash on Delivery": cash_delivery,
  "Convenience Store": konbini,
  Cash: cash,
  eBay: ebay,
  Walmart: walmart,
  "TikTok Shop": tiktok_shop,
  "Money Order": money_order,
  "Manual / Offline": offline,
  "Store Credit": Images.shopify
}

// export const paymentMethodsNames = {
//   affirm: "Affirm",
//   afterpay_clearpay: "Afterpay / Clearpay",
//   alipay: "Alipay",
//   amazon_pay: "Amazon Pay",
//   bancontact: "Bancontact",
//   blik: "BLIK",
//   cashapp: "Cash App",
//   customer_balance: "Customer Balance",
//   eps: "EPS",
//   ideal: "iDEAL",
//   kakao_pay: "Kakao Pay",
//   klarna: "Klarna",
//   kr_card: "KR Card",
//   link: "Link",
//   none: "None",
//   p24: "P24 (Przelewy24)",
//   paypal: "PayPal",
//   pix: "PIX",
//   samsung_pay: "Samsung Pay",
//   sepa_debit: "SEPA Debit",
//   twint: "Twint",
//   us_bank_account: "US Bank Account",
//   apple_pay: "Apple Pay",
//   google_pay: "Google Pay",
//   link_card: "Link Card",
//   naver_pay: "NAVER Pay",
//   ach_credit_transfer: "ACH Credit Transfer",
//   crypto: "Crypto",
//   wechat_pay: "WeChat Pay",
//   amex_express_checkout: "Amex Express Checkout",
//   masterpass: "Masterpass",
//   acss_debit: "ACSS Debit",
//   au_becs_debit: "AU BECS Debit",
//   bacs_debit: "BACS Debit",
//   billie: "Billie",
//   boleto: "Boleto",
//   cartes_bancaires: "Cartes Bancaires",
//   fpx: "FPX",
//   giropay: "GiroPay",
//   grabpay: "GrabPay",
//   konbini: "Konbini",
//   mb_way: "MB WAY",
//   mobilepay: "MobilePay",
//   multibanco: "Multibanco",
//   nz_bank_account: "NZ Bank Account",
//   oxxo: "OXXO",
//   payco: "Payco",
//   paynow: "PayNow",
//   paypay: "PayPay",
//   payto: "PayTo",
//   pay_by_bank: "Pay by Bank",
//   promptpay: "PromptPay",
//   radar_options: "Radar Options",
//   revolut_pay: "Revolut Pay",
//   satispay: "Satispay",
//   sofort: "SOFORT",
//   swish: "Swish",
//   zip: "Zip",
//   stripe_account: "Stripe Account",
//   shopify_pay: "Shopify Pay",
//   upi: "UPI",
//   bizum: "Bizum",
// };
